<template>
    <footer class="footer">
        &copy; {{ (new Date()).getFullYear() }} <a :href="config.Params.MainURL" target="_blank">{{ config.Params.SiteName }}</a>
    </footer>
</template>

<script>

    export default {
        props:["config"],
    }

</script>
<style scoped>

.footer {
    margin: 0;
    padding:5px 5px 5px 30px;
}
</style>